interface GalleryCardPrpos {
  item: {id:number | null, url: string}
}

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const GalleryCard = ({item}: GalleryCardPrpos) => {
  const height = Math.floor(Math.random() * 150) + 150;
  return (
    <div className="w-full overflow-hidden rounded-lg" style={{ height }}>
      <img
        src={`${storageURL}/${item.url}`}
        alt=""
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover rounded-lg"
      />
    </div>
  )
}

export default GalleryCard
